import { render } from "./UserAdd.vue?vue&type=template&id=317de07f"
import script from "./UserAdd.vue?vue&type=script&lang=ts"
export * from "./UserAdd.vue?vue&type=script&lang=ts"
script.render = render

export default script